export const DEFAULT_NEST_NAME = 'Default'
